(function(){
     'use strict';

     angular
        .module('app')
        .factory('GenerallabService', GenerallabService);

    GenerallabService.$inject = ['$http'];

    function GenerallabService($http){

        var service = {
        	centros : false,
            optionsEspecies : {
            	//data:[{id: "0003", text: "1"}],
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getespecies",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	                
	            },
	            
	        },
	        optionsVet: {
	        	//data:[{id: "0003", text: "1"}],
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getveterinarios",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	                
	            },
	        },

	        optionsAtt: {
	        	//data:[{id: "0003", text: "1"}],
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getatt",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	                
	            },
	        },
	        optionsRaces : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getraces",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsIdiomas : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getidiomas",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsProvincias: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getprovincias",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      per_page: 20,
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsMunicipis: {
	        	ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getmunicipis",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      //provincia: vm.provincia,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsSexo : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getsexos",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsEstado : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getestados",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsCentros : {
	            ajax: {
	                headers: { 'Content-Type': 'application/json' },
	                url: "/uranolab/getcentros",
	                dataType: 'json',
	                delay: 250,
	                data: function (params) {
	                    return {
	                      q: params.term, // search term
	                      page: params.page,
	                      lang_id: lang_id,
	                      //especieseleccionada: vm.newAnimal.especie,//SELECCIONAR EN CADA CONTROLLER
	                      per_page: 20
	                    };
	                },
	                processResults: function (data, params) {
	                    // parse the results into the format expected by Select2
	                    // since we are using custom formatting functions we do not need to
	                    // alter the remote JSON data, except to indicate that infinite
	                    // scrolling can be used
	                    params.page = params.page || 1;
	                    return {
	                      results: data.items,
	                      pagination: {
	                        more: (params.page * 1) < data.total_count
	                      }
	                    };
	                }
	            }
	        },
	        optionsSinglePicker : {
	            singleDatePicker: true,
	            maxDate : moment(),
	            showDropdowns: true,
	            //timezone:'CET',
	            opens:'center',
	            alwaysShowCalendars: true,
	            showCustomRangeLabel: false,
	            locale: {
	                applyLabel: "Aplicar",
	                cancelLabel: 'Cancelar',
	                clearLabel: 'Limpiar',
	                separator: ' - ',
	                format: "DD-MM-YYYY",
	                daysOfWeek: ['Dm', 'Ln', 'Mr', 'Mi', 'Jv', 'Vi', 'Sa'],
                    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                    firstDay: 1
	            },
	            ranges: {
	                'Hoy': [moment(), moment()],
	                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
	                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
	                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
	                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
	                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
	            }
	        },
	        optionsMultiplePicker : {
	            maxDate : moment(),
	            opens:'center',
	            alwaysShowCalendars: true,
	            showCustomRangeLabel: false,
	            locale: {
	                applyLabel: "Aplicar",
	                cancelLabel: 'Cancelar',
	                clearLabel: 'Limpiar',
	                separator: ' - ',
	                format: "DD-MM-YYYY",
	            },
	            ranges: {
	                'Hoy': [moment(), moment()],
	                'Ayer': [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
	                'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
	                'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
	                'Mes actual': [moment().startOf('month'), moment().endOf('month')],
	                'Mes anterior': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
	            },
	            /*changeCallback: function(){
	                $timeout(function(){
	                    vm.init();
	                });
	            },*/
	            /*eventHandlers: {
	                'apply.daterangepicker': function(event, picker) { $timeout(function(){
	                    vm.init();
	                }); },
	                'cancel.daterangepicker': function(event, picker) { $timeout(function(){
	                    vm.init();
	                }); }
	            },
	            cancelOnOutsideClick:true*/
	        },
	        monedero : 0
        };

        return service;
 		

    }
})();